export const refs = {
    form: document.querySelector('#task-form'),
    tasksList: document.querySelector(".tasks-list"),
    themeToggle: document.querySelector('#themeToggle')
}